import { withI18n } from 'react-i18next';
import CheckoutCardPrintable from './CheckoutCardPrintable';

export const pureComponent = CheckoutCardPrintable;
export default withI18n()(CheckoutCardPrintable);
